import { render, staticRenderFns } from "./SupplierSKU.vue?vue&type=template&id=0d2a3cf9&scoped=true&"
import script from "./SupplierSKU.vue?vue&type=script&lang=js&"
export * from "./SupplierSKU.vue?vue&type=script&lang=js&"
import style0 from "./SupplierSKU.vue?vue&type=style&index=0&id=0d2a3cf9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2a3cf9",
  null
  
)

export default component.exports